import { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useCartStore from "../../shared/services/store/usecart";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import useAuth from "../../shared/services/store/useAuth";
import Cartsidebar from "../../shared/components/CheckoutandCart/Cartsidebar";
import { apigetallHomeNotifications } from "../../shared/services/apihomenotifications/apiHomeNotifications";
import Marquee from "react-fast-marquee";
import { apigetDownloadEnabledAffairs, apigetHeaderEnabledAffairs } from "../../shared/services/apiCurrentAffairs/apicurrentaffairs";


export default function Header() {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { logout, userdetails } = useAuth();
  const navigate = useNavigate();
  let isMounted = true;
  const [notifications, setNotifications] = useState([]);
  const [headerAffairTypes, setHeaderAffairTypes] = useState([]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    if (location.hash === "#contact-us") {
      setTimeout(() => {
        const element = document.getElementById("contact-us");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    }
  }, [location]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const { cart } = useCartStore();

  const getDisplayLetter = () => {
    if (userdetails?.Role === 'Admin' || userdetails?.Role === 'Student') {
      return userdetails.Username?.charAt(0).toUpperCase();
    } else {
      return userdetails?.First_Name?.charAt(0).toUpperCase();
    }
  };

  const fetchNotifications = useCallback(async () => {
    try {
      const res = await apigetallHomeNotifications();
      if (res && res.resdata) {
        setNotifications(res.resdata);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }, []);

  //  const fetchHeaderAffairTypes = useCallback(async () => {
  //   try {
  //     const res = await apigetHeaderEnabledAffairs();
  //     if (res && res.data && res.data.length > 0) {
  //       const uniqueTypes = [...new Set(res.data.map(item => item.Current_Affair_Type))];
  //       setHeaderAffairTypes(uniqueTypes);
  //     } else {
  //       setHeaderAffairTypes([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching header affair types:", error);
  //     setHeaderAffairTypes([]);
  //   }
  // }, []);

  
  useEffect(() => {
    fetchNotifications();
    // fetchHeaderAffairTypes();
  }, [fetchNotifications, ]); // fetchHeaderAffairTypes

    const generalNotifications = notifications.filter(
      (notification) => notification.Notification_type === "General_Notification"
    );
 
 

  return (
    <>
      <header className="sticky z-40 top-14 md:top-14 lg:top-0 ">
        <div className="grid text-sm bg-white border-b lg:grid-cols-1 xl:grid-cols-12">
        {generalNotifications.length > 0 && (
          <div className="flex items-center justify-center w-full py-2 text-black bg-gray-100 border-b md:col-span-full lg:col-span-8">
            <Marquee pauseOnHover={true} speed={80}>
              {generalNotifications.map((notification) => (
                <Link key={notification._id} to={notification.Notification_Link} target="_blank" rel="noopener noreferrer" className="px-6 text-xs font-semibold uppercase border-r-2 hover:text-regal-yellow sm:text-sm border-r-black/20">
                  {notification.Notification_Title}
                </Link>
              ))}
            </Marquee>
          </div>
        )}

        <nav className="relative w-full px-4 md:col-span-full lg:col-span-4 sm:px-6 lg:px-8" aria-label="Global">
          <div className="flex items-center justify-center py-0 xl:py-3 xl:justify-end gap-x-3 sm:gap-x-5">
           
            <div className="items-center hidden py-2 lg:flex gap-x-3 sm:gap-x-5 xl:py-0">
               <Link to={"/athena-study-hall"} target="_blank">
             <div className="px-4 py-2 border-l-4 rounded-lg shadow-sm bg-gradient-to-r from-regal-yellow/20 to-regal-blue/20 border-regal-yellow">
              <h2 className="text-base font-bold tracking-wide text-gray-800 sm:text-lg">
                <span className="inline-block">Visit Our</span>{" "}
                <span className="text-regal-blue">Study Hall</span>
              </h2>
            </div>
            </Link>
              <Link onClick={scrollToTop} 
                className="inline-flex items-center justify-center px-3 py-2 text-sm font-bold leading-6 text-center text-white transition-all duration-300 ease-in-out rounded-lg sm:px-4 sm:py-3 sm:text-base gap-x-2 bg-regal-blue hover:bg-gradient-to-l hover:from-regal-yellow hover:to-regal-blue" 
                to="/application-form"
              >
                Apply Now
              </Link>

              {/* <div className="relative cart">
                <FontAwesomeIcon icon={faShoppingCart} size="lg" className="text-gray-700 cursor-pointer hover:text-regal-blue" onClick={toggleSidebar} />
                {cart?.length > 0 && (
                  <span className="absolute flex items-center justify-center w-5 h-5 text-xs text-white bg-red-600 rounded-full -top-2 -right-2">
                    {cart.length}
                  </span>
                )}
              </div> */}

              <div className="hs-dropdown [--placement:bottom-right] relative inline-flex">
                <button type="button"
                  className="w-[2.375rem] h-[2.375rem] inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
                >
                  {userdetails ? (
                    <div className="inline-flex items-center justify-center w-[38px] h-[38px] rounded-full bg-regal-blue ring-2 ring-white">
                      <span className="text-lg font-bold text-white">
                        {getDisplayLetter()}
                      </span>
                    </div>
                  ) : (
                    <div className="inline-flex items-center justify-center w-[38px] h-[38px] rounded-full bg-gray-100 ring-2 ring-white">
                      <i className="text-xl text-gray-500 fi fi-rr-user"></i>
                    </div>
                  )}
                </button>

                <div className="hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-60 bg-white shadow-md rounded-lg p-2" aria-labelledby="hs-dropdown-with-header">
                  <div className="px-5 py-3 -m-2 rounded-t-lg bg-secondary">
                    <p className="text-sm text-white">Signed in as {userdetails?.First_Name}</p>
                    <p className="mt-3 text-sm font-medium text-white">{userdetails?.Email}</p>
                  </div>
                  <div className="py-2 mt-2 first:pt-0 last:pb-0">
                    {userdetails ? (
                      <>
                        {userdetails?.Role === "Admin" && (
                          <Link to="/dashboard/home" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 cursor-pointer">
                            <i className="fi fi-rr-dashboard-panel"></i>
                            Admin Dashboard
                          </Link>
                        )}
                        {userdetails?.Role === "Student" && (
                          <Link to="/dashboard/studenthome" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 cursor-pointer">
                            <i className="fi fi-rr-dashboard-panel"></i>
                            My Dashboard
                          </Link>
                        )}
                        {userdetails?.Role === "Customer" && (
                          <>
                            <Link to="/myaccount" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500">
                              <i className="mt-1 font-semibold fi fi-rr-portrait"></i>
                              My Account
                            </Link>
                            <Link to="/myorder" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500">
                              <i className="mt-1 fi fi-br-order-history"></i>
                              My Order
                            </Link>
                          </>
                        )}
                        <Link onClick={handleLogout} className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 cursor-pointer">
                          <i className="mt-1 fi fi-br-sign-out-alt"></i>
                          Logout
                        </Link>
                      </>
                    ) : (
                      <Link to="/login" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500">
                        <i className="mt-1 fi fi-br-sign-in-alt"></i>
                        Login
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        </div>
        {/* <div className="z-30 bg-blue-100 ">
          <div className="max-w-[85rem] mx-auto p-2">
            <div className="">
              <div className="flex space-x-5 overflow-x-auto slim-scrollbar-test">
                <Link  to="/current-affairs" className="font-semibold transition-colors whitespace-nowrap hover:text-regal-blue">
                  All Current Affairs
                </Link>
                {headerAffairTypes.length > 0 ? (
                  <>
                    {headerAffairTypes.map((affairType, index) => (
                      <Link key={index} to={`/current-affairs?type=${encodeURIComponent(affairType)}`} className="flex font-semibold transition-colors whitespace-nowrap hover:text-regal-blue">
                        <span>|</span>
                        <p className="ml-5">{affairType}</p> 
                      </Link>
                    ))}
                  </>
                ) : null}
                <span>|</span>
                <Link to="/monthly-current-affairs" className="font-semibold transition-colors whitespace-nowrap hover:text-regal-blue">
                    Monthly Current Affairs 
                </Link>
                <span>|</span>
                <Link to="/downloads" className="font-semibold transition-colors whitespace-nowrap hover:text-regal-blue">
                  Downloads
                </Link>

              </div>
            </div>
          </div>
        </div> */}
      </header>
   
     
      
      <div className="hidden lg:block">
        <Cartsidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      </div>
    </>
  );
}